import { createStore } from 'vuex'

export default createStore({
	state: {
		isLoggedIn: window.selena_config && selena_config['IS_LOGGED_IN'],
		uuid: null,
	},
	mutations: {
		SET_DATA_BY_KEY(state, data) {
			Object.keys(data).map((key) => {
				if (key in state) {
					state[key] = data[key]
				}
			})
		},
		MUTATE_LOGIN(state, flag = false) {
			state.isLoggedIn = flag
		},
	},
	actions: {},
	modules: {},
})
